import { IntercomContext } from 'contexts/intercom';
import { Layout } from 'modules/entrypoint/LayoutCommon';
import type { NotFoundError } from 'navi';
import { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ErrorBlock } from './ErrorBlock';

export const NotFoundContent = () => {
  const { t } = useTranslation(['common', 'glossary']);
  const { show } = useContext(IntercomContext);

  return (
    <>
      <Helmet>
        <meta content="404" name="prerender-status-code" />
      </Helmet>
      <ErrorBlock
        buttonText={t('glossary:home')}
        handleOpenSupport={show}
        subText={t('common:errorsPages.notFound.subText')}
        text={t('common:errorsPages.notFound.text')}
      />
    </>
  );
};

export const NotFoundBlock = () => (
  <Layout>
    <NotFoundContent />
  </Layout>
);

export const NotFoundLayout = (_: NotFoundError) => <NotFoundBlock />;
